import { FC, ReactNode, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import TenantService from '../../services/TenantService'
import { getNavigation, getSubMenus, NAVIGATION_KEY } from '../../utils/constants/Navigation'
import { makeRedirectionPage } from '../../utils/helpers/RedirectionHelper'
import { Grid, LogoAnimation, Navigation } from '../atoms'
import Header from '../molecules/Header'
import {
  CompanyTitleWrapper,
  MainContent,
  MainHeaderWrapper,
  MainNavigationWrapper,
  MainNavigationInner,
  MainWrapper,
  StyledMain,
} from './style'
import { UrlHelper } from '../../utils/helpers'
import { usePermissionPage } from '../hooks'
import useOnboardingNextPage from '../hooks/useOnboardingNextPage'

interface IMain {
  children?: ReactNode
}

const Main: FC<IMain> = ({ children }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { data, error, isValidating } = TenantService.getCurrentUser()
  const navigationPathname = UrlHelper.getFirstPathItem(pathname)
  const targetMainNavigation = NAVIGATION_KEY.MAIN
  const mainNavigation = getNavigation(
    targetMainNavigation,
    t,
    data?.data?.tenant?.enabledFeatures,
    data?.data?.role
  )
  const subMenus = getSubMenus(t, data?.data?.tenant)
  const [permittedPage] = usePermissionPage(pathname, data?.data)
  const companyTitle = data?.data?.tenant?.invoice?.companyTitle || ''
  const [nextPageInfo, nextPageAction] = useOnboardingNextPage()

  useEffect(() => {
    nextPageAction()
  }, [nextPageInfo])

  if (isValidating && !data) return <LogoAnimation />

  return (
    <StyledMain>
      <MainHeaderWrapper>
        <Grid>
          <Header
            mobile={{ mainNavigation, subMenus }}
            pathname={navigationPathname}
            onLogoClick={() => {
              const { props }: any = makeRedirectionPage({
                data,
                error,
                handler: navigate,
                isValidating,
                pathname,
                search,
                redirectToHome: true,
              })

              window?.location?.replace(`${window?.location?.origin}${props?.pathname}`)
            }}
          />
        </Grid>
      </MainHeaderWrapper>
      <MainNavigationWrapper>
        <Grid>
          <MainNavigationInner>
            <Navigation
              data={mainNavigation}
              handler={navigate}
              pathname={navigationPathname}
              showIcon={false}
            />
            <CompanyTitleWrapper>{companyTitle}</CompanyTitleWrapper>
          </MainNavigationInner>
        </Grid>
      </MainNavigationWrapper>
      <Grid>
        <MainWrapper>
          <MainContent>{permittedPage ? children : <div>{t('generic.notAuthorizedPage')}</div>}</MainContent>
        </MainWrapper>
      </Grid>
    </StyledMain>
  )
}

export default Main
